/** ツリー機能キー名 */
export const EXECUTE_FUNCTION_TYPE_OBD_ALL_DTC = "obdAllDtc";
export const EXECUTE_FUNCTION_TYPE_OBD_INDIVIDUAL = "obdIndividual";
/** ツリーノード作成用 */
export const FUNCTION_KEY_DATA_MONITOR = "dataMonitor";
export const FUNCTION_KEY_DTC = "obdDtc";
export const FUNCTION_KEY_ONBOARD_MONITOR_TEST = "onboardMonitorTest";
export const FUNCTION_KEY_ONBOARD_SYSTEM_TEST = "onboardSystemTest";
export const FUNCTION_KEY_VEHICLE_INFO = "vehicleInfo";
export const FUNCTION_KEY_P_DTC = "pDtc";
export const FUNCTION_KEY_DIAGNOSE_FREQUENCY = "diagnoseFrequency";
export const FUNCTION_KEY_READINESS_STATUS = "readinessStatus";

/** ALL DTC(OBD)の表示件数上限(この件数を超えたら取得を終了する) */
export const OBD_ALL_DTC_LIMIT = 5000;

/** FFD(最新)の表示件数上限(この件数を超えたら取得を終了する)*/
export const OBD_FFD_LATEST_LIMIT = 5000;

/** FFD(最古)の表示件数上限(この件数を超えたら取得を終了する)*/
export const OBD_FFD_OLDEST_LIMIT = 5000;

/** OBD オンボードモニタテストの表示件数上限(この件数を超えたら取得を終了する) */
export const OBD_ONBOARD_MONITOR_TEST_LIMIT = 5000;

/** OBD レディネスステータスの表示件数上限(この件数を超えたら取得を終了する) */
export const OBD_READINESS_STATUS_LIMIT = 5000;

export const FUNCTION_MAPPING = [
  {
    functionKey: FUNCTION_KEY_DATA_MONITOR,
    menuSupportKey: "dataMonitor",
    messageKey: "fixed_resource.obd_menu_datamonitor",
  },
  {
    functionKey: FUNCTION_KEY_DTC,
    menuSupportKey: "diagCode",
    messageKey: "fixed_resource.obd_menu_dtc",
  },
  {
    functionKey: FUNCTION_KEY_ONBOARD_MONITOR_TEST,
    menuSupportKey: "onboardMonitorTest",
    messageKey: "fixed_resource.obd_menu_monitortest",
  },
  {
    functionKey: FUNCTION_KEY_ONBOARD_SYSTEM_TEST,
    menuSupportKey: "onboardSystemTest",
    messageKey: "fixed_resource.obd_menu_systemtest",
  },
  {
    functionKey: FUNCTION_KEY_VEHICLE_INFO,
    menuSupportKey: "vehicleInfo",
    messageKey: "fixed_resource.obd_menu_infotype",
  },
  {
    functionKey: FUNCTION_KEY_P_DTC,
    menuSupportKey: "permanentDtc",
    messageKey: "fixed_resource.obd_menu_pdtc",
  },
  {
    functionKey: FUNCTION_KEY_DIAGNOSE_FREQUENCY,
    menuSupportKey: "diagnoseFrequency",
    messageKey: "fixed_resource.obd_menu_jumpr",
  },
  {
    functionKey: FUNCTION_KEY_READINESS_STATUS,
    menuSupportKey: "readinessStatus",
    messageKey: "fixed_resource.obd_menu_readiness_status",
  },
];
